module.exports = __webpack_public_path__ + "static/media/6732.1e3c380d.jpg";